import classNames from 'classnames';
import React from 'react';
import { TOOLTIP_SECTIONS } from '../../enums';
import TooltipWrapper from '../TooltipWrapper/TooltipWrapper';

import styles from './styles.module.scss';
import { SToggle } from '@avalara/skylab-sdk/react';

interface Props {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  classnames?: string;
  disabled?: boolean;
  tooltipText?: string;
}

/** Custom checkbox, it receice label & value & onChange and a optional parameter classnames */
function FieldToggleCheckbox(props: Props) {
  const {classnames, label, value, onChange, disabled, tooltipText} = props;
  return (
    <div
      className={classNames(
        styles.toggleCheckbox,
        disabled && styles.disabled,
        classnames,
      )}
    >
      <label>
        {label ? (
          <TooltipWrapper
            tooltipSection={TOOLTIP_SECTIONS.Common}
            tooltipKey={tooltipText || label}
          >
            <span>{label}</span>
          </TooltipWrapper>
        ) : (
          label
        )}

        <SToggle checked={value} onS-toggle={(e: CustomEventInit) => {
          if (e.detail.checked === value) {
            return;
          }
          onChange(e.detail.checked);
        }} />
      </label>
    </div>
  );
}

export default FieldToggleCheckbox;
